export default __webpack_public_path__ + "edit.bed1fd47b214af6a.svg";